import { render, staticRenderFns } from "./addresses-edit-form.vue?vue&type=template&id=0c9ea7d6&"
import script from "./addresses-edit-form.vue?vue&type=script&lang=js&"
export * from "./addresses-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports